<template>
  <el-dialog
    v-el-drag-dialog
    no="dialog"
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_Booking')"
    width="850px"
    :close-on-click-modal="false"
    class="app-main-inner"
  >
    <cargo-ag-grid
      no="grid"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="jobs"
      style="width: 100%;height: 300px;"
      @gridReady="params=>{gridApi=params.api}"
    />
    <span slot="footer">
      <el-button no="Confirm" type="primary" @click="enterHandler">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button no="Cancel" @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      no="templateSelectorDialog"
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
  </el-dialog>
</template>

<script>
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { bookingRequest } from '@/api/AirExport/aeBooking'

export default {
  name: 'AeBookingDialog',
  components: { cargoTemplateSelectorDialog },
  props: {
    visible: { type: Boolean, required: true },
    flight: { type: Object, required: true },
    jobs: { type: Array, required: true }
  },
  data() {
    return {
      innerVisible: this.visible,
      templateSelectorDialog: {
        visible: false,
        ctx: null,
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    // 扩展data
    Object.assign(this, {
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 50,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('Payment.customer'),
          field: 'customerId',
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('Billing.WayBillNumber'),
          field: 'mbl',
          cellRenderer: params => {
            return ColumnUtils.mawbNoLabelFun(params.value)
          },
          width: 100
        }, {
          headerName: this.$t('Payment.portOfDestination'),
          field: 'destinationPortCode',
          width: 100
        }, {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantityBooking',
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          },
          width: 100
        }, {
          headerName: this.$t('SeaExport.Weight2'),
          field: 'weightBooking',
          cellRenderer: params => {
            return ColumnUtils.number1ColumnLabelFunc(params.value)
          },
          width: 100
        }, {
          headerName: this.$t('SeaExport.Cubage'),
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          field: 'cubageBooking',
          width: 100
        }
      ],
      gridApi: null
    })
  },
  methods: {
    enterHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.info(this.$t('queryJob.selectBookedOrder'))
        return
      }
      const jobUuidList = Array.from(rows, p => p.uuid)
      bookingRequest({
        flightUuid: this.flight.uuid,
        jobUuidList: jobUuidList
      }).then(res => {
        this.$confirm(this.$t('Message.SaveSuccessfully'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          showCancelButton: false,
          closeOnClickModal: false,
          type: 'success'
        }).then(() => {
          this.templateSelectorDialog.category = 'AELIST'
          this.templateSelectorDialog.data = { 'USER_ID': this.$store.getters.userId, 'JOB_UUID': jobUuidList }
          this.templateSelectorDialog.visible = true
        }).catch()
        this.innerVisible = false
      })
    }
  }
}
</script>
